import { render } from "./DeviceType.vue?vue&type=template&id=96fceaa6&scoped=true"
import script from "./DeviceType.vue?vue&type=script&lang=js"
export * from "./DeviceType.vue?vue&type=script&lang=js"

import "./DeviceType.vue?vue&type=style&index=0&id=96fceaa6&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96fceaa6"]])

export default __exports__